export const JOB_STATUS_ENUM = {
  JOB_CREATED: "JOB_CREATED",
  JOB_ALLOCATED: "JOB_ALLOCATED",
  QUOTATION_IN_PROGRESS: "QUOTATION_INPROGRESS",
  REQUEST_APPROVAL: "REQUEST_APPROVAL",
  QUOTATION_REJECTED: "QUOTATION_REJECTED",
  QUOTATION_APPROVED: "QUOTATION_APPROVED",
};

export const RATING_RANGE = {
  ZERO_RANGE: ["0", "0.9"],
  ONE_RANGE: ["1.0", "1.4"],
  ONE_POINT_FIVE_RANGE: ["1.5", "1.9"],
  TWO_RANGE: ["2.0", "2.4"],
  TWO_POINT_FIVE_RANGE: ["2.5", "2.9"],
  THREE_RANGE: ["3.0", "3.4"],
  THREE_POINT_FIVE_RANGE: ["3.5", "3.9"],
  FOUR_RANGE: ["4.0", "4.4"],
  FOUR_POINT_FIVE_RANGE: ["4.5", "4.9"],
  FIVE_RANGE: ["5", "5"],
};
